/* eslint-disable react-hooks/exhaustive-deps */
import { WithAnalytics } from "@base/utils/hoc/withSendPageAnalytics";
import Button from "@components/atoms/button";
import { homeActions } from "@components/features/home/home.slice";
import { GenericDialog } from "@components/molecules/dialog";
import Header from "@components/molecules/header";
import Layout from "@components/molecules/layout";
import { LoaderSnackbarWrapperActions } from "@components/organisms/LoaderSnackbarWrapper/LoaderSnackbarWrapper.slice";
import { auth } from "@config/firebase/firbaseConfig";
import { signOut } from "firebase/auth";
import { debounce } from "lodash";
import { useState } from "react";
import { ConnectedProps, connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { accountActions } from "./account.slice";
import { Content, Typography, TypographyWrapper } from "./account.styled";

type ReduxProps = ConnectedProps<typeof connector>;

const Account = ({ setUser, deleteUser, setAlert, resetUser }: ReduxProps) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = async () => {
    const response = await deleteUser();
    if (response.meta.requestStatus === "fulfilled") {
      handleClose();
      signOut(auth)
        .then(() => {
          resetUser();
          localStorage.clear();
          window.location.href = "/";
        })
        .catch((error) => {
          setAlert({
            alert: {
              isVisible: true,
              message: `${error}`,
              type: "error",
            },
          });
        });
    }
  };

  const handleBack = debounce(() => {
    navigate("/settings");
  }, 300); // This is to prevent double clicks

  return (
    <Layout
      isLayout
      HeaderChildren={<Header title="Account" handleBack={handleBack} />}
      CardChildren={<></>}
    >
      <Content>
        <TypographyWrapper>
          <Typography>Deleting your account will do the following:</Typography>
          <Typography color="#E53E3E">Log you out on all devices</Typography>
          <Typography color="#E53E3E">
            Delete all of your account information
          </Typography>
        </TypographyWrapper>
        <Button
          iscta
          textColor={"#FFF"}
          color="error"
          text={"Delete Account"}
          type={"button"}
          onClick={handleOpen}
        />
        <GenericDialog
          open={open}
          title="Delete Account"
          content="Are you sure? All the details and records will be deleted once confirmed. This action cannot be undone."
          onClose={handleClose}
          onConfirm={handleConfirm}
        />
      </Content>
    </Layout>
  );
};

const mapDispatchToProps = {
  setUser: homeActions.setUser,
  resetUser: homeActions.reset,
  deleteUser: accountActions.deleteUser,
  setAlert: LoaderSnackbarWrapperActions.setGlobalAppearances,
};

const connector = connect(undefined, mapDispatchToProps);
const AccountRedux = connector(WithAnalytics(Account));

export { AccountRedux as Account };
